import ActionButton from "./styled-components/ActionButton";
import ActionGroup from "./styled-components/ActionGroup";
import Container from "./styled-components/Container";
import Dialog from "./styled-components/Dialog";
import Title from "./styled-components/Title";

interface SaveDialogProps {
  onSave(): void;
  onContinue(): void;
}

function SaveDialog({ onContinue, onSave }: SaveDialogProps) {
  return (
    <Container>
      <Dialog>
        <Title>
          ¿Quieres guardar tu huella de carbono y terminarla después?
        </Title>
        <ActionGroup>
          <ActionButton onClick={onContinue}>Continuar</ActionButton>
          <ActionButton onClick={onSave} secondary>
            Guardar
          </ActionButton>
        </ActionGroup>
      </Dialog>
    </Container>
  );
}

export default SaveDialog;
